(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparqwear-actions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sqw-copy]');
    if (!b) return;
    try {
      await navigator.clipboard.writeText(b.dataset.sqwCopy);
      b.textContent = 'Kopyalandı';
    } catch (err) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparqwear-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sqw-scroll-top]');
    if (!a) return;
    e.preventDefault();
    const target = document.querySelector('[data-sqw-pay]') || document.querySelector('product-form-component') || document.body;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparqwear-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sqw-more-btn]');
    if (!btn) return;
    const list = btn.closest('.sqw-prev').querySelector('[data-sqw-more]');
    const hidden = [...list.querySelectorAll('[data-sqw-more-item][hidden]')];
    hidden.slice(0, 6).forEach((li) => (li.hidden = false));
    if (hidden.length <= 6) btn.closest('.sqw-prev__more').remove();
  });

  } catch(e) { console.error(e); }
})();
})();
